import {
  Form,
  Input,
  Select,
  InputNumber,
  Checkbox,
  Button,
  Card,
  Spin,
  Tag,
  Icon,
  Tooltip,
} from "antd";
import React, { Component } from "react";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { AccountService } from "../../services/account/AccountService";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "../accounts/Accounts.css";
import "../accounts/AccountForm.css";
import "../accounts/CreateAccount.css";
import AuthorizedOnly from "../general/AuthorizedOnly";
import { Constants } from "../../data/constants";

class CreateAccountMSISDN extends Component {
  accountService = new AccountService();
  constants = new Constants();
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("createAccountMSISDN");
    this.state = {
      accountMSizeN: {},
      isFetching: false,
      formLayout: "inline",
      loading: false,
      inputValue: "",
      privileges: [],
    };
  }

  componentDidMount() {}

  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    this.props.form.validateFields(async (err, values) => {
      try {
        values['msisdn'] = this.props.context.user.msisdnType === 'alphanumeric' ? values['msisdnAlph'] : values['msisdn'];
        if (!err) {
          this.setState({ loading: true });
          let data = await this.accountService.addAccountMSISDN(
            this.props.context.session_id,
            values
          );

          this.setState({ accountMSizeN: data.id });
          showSuccessToast("Added Successfully");
          this.setState({ loading: false });
          this.props.form.resetFields();
          history.push("/home/accountMsisdn");
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    let { isFetching } = this.state;

    return (
      <Page title={"Create Account MSISDN"} hasBackArrow={true}>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <Card
            style={{
              marginTop: "10px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            }}
            bordered={false}
          >
            <Form className="form-style" {...formItemLayout}>
              <Form.Item
                style={{
                  display:
                    this.props.context.user.msisdnType === "alphanumeric"
                      ? "block"
                      : "none",
                }}
                label="MSISDN"
                {...formItemLayout}
              >
                {getFieldDecorator("msisdnAlph", {
                  rules: [
                    {
                      type: "string",
                      message: "The input is not valid ",
                      pattern: "^[a-zA-Z0-9_@$.*]*$",
                    },
                    {
                      required:
                        this.props.context.user.msisdnType === "alphanumeric"
                          ? true
                          : false,
                      message: "Please enter Msisdn",
                    },
                  ],
                })(<Input />)}
              </Form.Item>
              <Form.Item
                label="MSISDN"
                {...formItemLayout}
                style={{
                  display:
                    this.props.context.user.msisdnType !== "alphanumeric"
                      ? "block"
                      : "none",
                }}
              >
                {getFieldDecorator(
                  "msisdn",

                  {
                    rules: [
                      {
                        required:
                          this.props.context.user.msisdnType !== "alphanumeric"
                            ? true
                            : false,
                        min: 11,
                        message: "MSISDN must be 11 digits",
                        pattern: new RegExp("^[0-9]{11}$"),
                      },
                    ],
                  }
                )(<Input maxLength={11} />)}
              </Form.Item>

              <Form.Item
                wrapperCol={{
                  xs: { span: 24, offset: 0 },
                  sm: { span: 16, offset: 8 },
                }}
              >
                <Button
                  className="button-submit"
                  type="primary"
                  onClick={this.handleConfirm}
                  size={"small"}
                  loading={this.state.loading}
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        )}
      </Page>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateAccountMSISDN))
);
